@if (showBar && bar && !bar.hidden) {
    <div class="bg-e-white" [ngClass]="{'sticky top-20 md:top-36 z-20': bar.sticky}">
        <div class="min-h-7 flex flex-row  content-center justify-center gap-1 px-2 pb-1 bg-{{bar.bgcolor}}" [ngClass]="{'w-full max-w-[1428px] mx-auto rounded-lg': !bar.fullwidth}">
            @if(bar.body){
                @for (content of bar.body.content; track $index) {
                    @if(content.type ==='paragraph'){
                        <div class="text-{{bar.text_color}} flex content-center my-auto" [innerHTML]="content._rendered"></div>
                    }@else{
                    @switch (content?.attrs?.body[0]?.component){
                        @case ('CTA') {<app-cms-button [removeMargin]="true" [button]="content?.attrs?.body[0]" class="flex my-auto"></app-cms-button>}
                        @case ('feedbackwidget') {<app-cms-feedbackwidget [feedbackwidget]="content?.attrs?.body[0]" class="flex my-auto"></app-cms-feedbackwidget>   }
                      }
                    }
                    
                }
            }
        </div>
    </div>
}